if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Resolve the current, upgraded cart after any section replacement.
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.cart = cart && typeof cart.getSectionsToRender === 'function' &&
          typeof cart.renderContents === 'function' && typeof cart.setActiveElement === 'function' ? cart : null;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const bundleBox = this.form.hasAttribute('data-cherries-upsell') ? null : this.closest('product-info')?.querySelector('[data-cherries-bundle]');
        const isBundle = Boolean(bundleBox?.querySelector('input[value="bundle"]:checked:not(:disabled)') && bundleBox.dataset.protectorId);
        if (isBundle) {
          const bundleData = new FormData();
          const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
          bundleData.append('items[0][id]', formData.get('id'));
          bundleData.append('items[0][quantity]', String(quantity));
          bundleData.append('items[0][properties][_Cherries bundle]', 'case-protector');
          bundleData.append('items[1][id]', bundleBox.dataset.protectorId);
          bundleData.append('items[1][quantity]', String(quantity));
          bundleData.append('items[1][properties][_Cherries bundle]', 'case-protector');
          for (const [key, value] of formData.entries()) {
            if (key === 'sections' || key === 'sections_url') bundleData.append(key, value);
            else if (key.startsWith('properties[')) bundleData.append('items[0][properties][' + key.slice(11,-1) + ']', value);
            else if (key === 'selling_plan') bundleData.append('items[0][selling_plan]', value);
          }
          config.body = bundleData;
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (!response.status && isBundle) {
              if (this.cart?.tagName.toLowerCase() !== 'cart-drawer') {
                window.location.assign('/discount/' + encodeURIComponent(bundleBox.dataset.discountCode) + '?redirect=' + encodeURIComponent(window.routes.cart_url));
                return;
              }
              const cartState = await fetch(window.Shopify.routes.root + 'cart.js').then(result => result.json());
              const existingCodes = (cartState.discount_codes || []).map(discount => discount.code);
              const allocations = [...(cartState.cart_level_discount_applications || []), ...(cartState.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
              allocations.filter(discount => discount.type === 'discount_code').forEach(discount => existingCodes.push(discount.title));
              const discountCodes = [...new Set([...existingCodes.filter(Boolean), bundleBox.dataset.discountCode])];
              const discountedCartResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: discountCodes.join(','), sections: this.cart.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
              });
              const discountedCart = await discountedCartResponse.json();
              if (!discountedCartResponse.ok || discountedCart.status) {
                this.cart.renderContents(response);
                throw new Error('Your items are in the cart, but the bundle saving could not be applied. Please review your cart.');
              }
              response = discountedCart;
            }
            if (!response.status && !isBundle && window.CherriesScreenProtectorGift) {
              response = await window.CherriesScreenProtectorGift.addForCase(response, formData, this.cart);
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(e.message || 'Your items could not be added. Please try again.');
            this.error = false;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
